<template>
  <div>
    <h1>Services</h1>
    <p>We help governments, non-profits, corporations and community groups, find, process, and use
      data to make informed decisions.</p>

    <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="3">
      <b-col>
        <b-card>
          <b-card-header>Consulting</b-card-header>
          <b-card-body>
            <ul>
              <li>Data strategy</li>
              <li>Policy</li>
              <li>Racial equity</li>
              <li>Data assessment</li>
              <li>Leadership coaching</li>
            </ul>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col>
        <b-card>
          <b-card-header>Research</b-card-header>
          <b-card-body>
            <ul>
              <li>Data collection</li>
              <li>Data analysis</li>
              <li>Metric selection</li>
              <li>Focus group facilitation</li>
              <li>Demographic research</li>
              <li>Survey design</li>
              <li>Program evaluation</li>
              <li>Policy analysis</li>
              <li>Research dissemination</li>
            </ul>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col>
        <b-card>
          <b-card-header>Technology</b-card-header>
          <b-card-body>
            <ul>
              <li>Software development</li>
              <li>Data science</li>
              <li>Database query design</li>
              <li>Data migrations</li>
              <li>Data warehousing</li>
              <li>Dashboard design</li>
            </ul>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
};
</script>
